import { BookingCard } from '@/components/shared/booking-card';
import { Grid, CarouselProps, Carousel, Image } from 'antd';
import { useState } from 'react';

interface Props {
  photos: string[];
}

export default function GalleryAdminSection({ photos }: Props) {
  const config: CarouselProps = {
    centerMode: true,
    slidesToShow: 1,
    centerPadding: '0',
    className: 'dashboard-sessions-carousel',
    dots: true,
    arrows: true,
    autoplay: false,
    infinite: true,
  };

  return (
    <div className="gallery-carousel-container" style={{ padding: '20px 0' }}>
      <Carousel {...config}>
        {photos.map((photo, index) => (
          <div key={index} style={{ padding: '0 8px' }}>
            <Image
              src={photo}
              alt={`Gallery Image ${index + 1}`}
              width="100%"
              height={180}
              style={{
                borderRadius: '8px',
                objectFit: 'cover',
                cursor: 'pointer',
              }}
              preview={{
                mask: <div style={{ fontSize: '14px' }}>Preview Image</div>,
              }}
            />
          </div>
        ))}
      </Carousel>
    </div>
  );
}
